
import {Options, Vue} from "vue-class-component";
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot,} from '@headlessui/vue'

@Options({
  props: {
    size: {type: String, default: ""},
    bg: {type: String, default: "bg-white"},
    rounded: {
      type: String,
      default: ""
    },
    closeWhenOutsideClick: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      classes: ""
    };
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
  },
  created() {
    switch (this.size) {
      case 'screen':
        this.classes = "min-w-full h-full "
    }
    this.classes += this.bg + " "
    this.classes += this.rounded
  },
  methods: {
    closeModal(outside: number = 0) {
      if (outside === 1 && this.closeWhenOutsideClick) {
        this.show = false
      }
      if (outside === 0) {
        this.show = false
      }
    },
    openModal() {
      this.show = true
    },
  },
})
export default class Modal extends Vue {
}
